import { render, staticRenderFns } from "./InputGeneric.vue?vue&type=template&id=e984f2be&scoped=true"
import script from "./InputGeneric.vue?vue&type=script&lang=ts"
export * from "./InputGeneric.vue?vue&type=script&lang=ts"
import style0 from "./InputGeneric.vue?vue&type=style&index=0&id=e984f2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e984f2be",
  null
  
)

export default component.exports